'use client'

import { useEffect, useState } from 'react'
import { Undo2Icon, Redo2Icon } from 'lucide-react'
import { useEditorContext } from '@/components/ui/editor'
import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

const History = () => {
  const { editor, sourceMode } = useEditorContext()
  const [canUndo, setCanUndo] = useState(false)
  const [canRedo, setCanRedo] = useState(false)

  useEffect(() => {
    if (!editor) {
      return
    }

    const update = () => {
      setCanUndo(editor.can().undo())
      setCanRedo(editor.can().redo())
    }

    update()
    editor.on('transaction', update)

    return () => {
      editor.off('transaction', update)
    }
  }, [editor])

  if (!editor) {
    return null
  }

  return (
    <div className="flex items-center gap-1">
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            type="button"
            size="sm"
            variant="ghost"
            onClick={() => editor.chain().focus().undo().run()}
            disabled={!canUndo || sourceMode}
            tabIndex={-1}>
            <Undo2Icon />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Undo</p>
        </TooltipContent>
      </Tooltip>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            type="button"
            size="sm"
            variant="ghost"
            onClick={() => editor.chain().focus().redo().run()}
            disabled={!canRedo || sourceMode}
            tabIndex={-1}>
            <Redo2Icon />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Redo</p>
        </TooltipContent>
      </Tooltip>
    </div>
  )
}

export default History
